export const accountsStoreKey = 'accounts';
